import React from 'react';
import { Link } from 'react-router-dom';

const MoviesAdminCtaSection = () => {
  return (
    <section aria-labelledby="movies-admin-cta-title">
      <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-lg site-card text-center">
        <h2 id="movies-admin-cta-title" className="text-3xl font-bold text-gray-900">
          Voltar para Filmes
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Depois de publicar uma entrada, volte para conferir como ela ficou na lista.
        </p>
        <div className="mt-8">
          <Link
            to="/laboratorio/filmes"
            className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
          >
            Ir para Filmes
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MoviesAdminCtaSection;
